import _ from 'lodash'
import { AggregateField } from '../../../../domain/entity/WbsItemEntity'
import {
  FractionValue,
  SprintReportSummarizeValue,
  SprintReportValue,
} from '../../../../lib/functions/sprintReport'
import { dateV2Service } from '../../../../domain/value-object/DateV2'

type DateRange = {
  from: Date
  to: Date
}

export const summarizeValues = (
  values: { [date: string]: SprintReportValue },
  dateRange: DateRange,
  aggregateField: AggregateField
): SprintReportSummarizeValue => {
  const { from, to } = dateRange
  return summarize(
    Object.entries(values)
      .filter(([dateStr]) => {
        const date = dateV2Service.fromString(dateStr)
        if (!date) return false
        return from <= date && date <= to
      })
      .map(([, value]) => value),
    aggregateField
  )
}

const summarize = (
  values: SprintReportValue[],
  aggregateField: AggregateField
): SprintReportSummarizeValue => {
  const sum: SprintReportSummarizeValue = {
    numerator: 0,
    denominator: 0,
    wbsItemCodes: [],
  }
  values.forEach(v => {
    const fraction: FractionValue =
      aggregateField === AggregateField.WBS_ITEM_COUNT
        ? v.countBy
        : v.workloadBy
    sum.numerator += fraction.numerator
    sum.denominator += fraction.denominator
    sum.wbsItemCodes = _.union(sum.wbsItemCodes, v.wbsItemCodes ?? [])
  })
  return sum
}
